import { render } from "./AttributeDate.vue?vue&type=template&id=b87e2600&scoped=true"
import script from "./AttributeDate.vue?vue&type=script&lang=js"
export * from "./AttributeDate.vue?vue&type=script&lang=js"

import "./AttributeDate.vue?vue&type=style&index=0&id=b87e2600&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b87e2600"]])

export default __exports__